import { SelectV2, useSelectItems } from "@resource/atlas/select-v2";
import { getJobStatusDisplayText, JobStatusFilter } from "shared/jobs/types";

type JobStatusSelectProps = {
  value: JobStatusFilter;
  onChange: (value: JobStatusFilter) => void;
};

export function useJobStatusSelectItems() {
  return useSelectItems(
    (i) =>
      Object.values(JobStatusFilter).map((status) =>
        i.option({
          key: status,
          value: status,
          children: getJobStatusDisplayText(status),
        })
      ),
    []
  );
}

export function JobStatusSelect({ value, onChange }: JobStatusSelectProps) {
  const items = useJobStatusSelectItems();
  return (
    <SelectV2.Root
      value={value}
      setValue={(v) => onChange(v as JobStatusFilter)}
    >
      <SelectV2.Trigger className="w-full" />
      <SelectV2.Content items={items} />
    </SelectV2.Root>
  );
}
